import { Component, QueryList, ViewChildren } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ReponseQuestionnaireSante } from '@kv-common-components/kx-services';
import { CommonQuestionChapeauComponent } from '@kv-common-components/kv-common-components';
import { QuestionMotifComponent } from '../question-motif/question-motif.component';
@Component({
    selector: 'app-question-chapeau-component',
    templateUrl: './question-chapeau.component.html',
    styleUrls: [],
})
export class QuestionChapeauComponent extends CommonQuestionChapeauComponent {
    @ViewChildren(QuestionMotifComponent)
    sousQuestionsMotifs!: QueryList<QuestionMotifComponent>;
    constructor(protected logger: NGXLogger) {
        super(logger);
    }

    getReponse(): ReponseQuestionnaireSante[] {
        const sousReponses: ReponseQuestionnaireSante[] = [];

        this.sousQuestionsMotifs.forEach((question) => {
            sousReponses.push(question.getReponse());
        });
        return sousReponses;
    }
}
